module.exports = __webpack_public_path__ + "static/media/season-img1.6a001de9.jpg";